<template>
	<div class="item_sidebar manage-products-panel">
		<div class="inner_box with_select">
			<div class="title">Products</div>
			<v-button label="Manage Products" slim border @click="open=!open" />
		</div>

		<portal to="popup">
			<products-list-panel v-if="open" @close="open=false" :step="step" :products="products" />
		</portal>
	</div>
</template>

<script>
import VButton from '@/components/base/v-button';
import ProductsListPanel from '@/views/funnels/funnel-plus/steps/products/products-list-panel'

export default {
	name: 'manageProducts',
	props: ['title', 'value', 'options'],
	components: {VButton, ProductsListPanel},
	data: function () {
		return {
			open: false,
		}
	},
	computed: {
		products(){
			return this.$store.state.page.products;
		},
		step(){
			return this.$store.state.page.step;
		},
		funnelId(){
			return this.$store.state.page.initial.funnel;
		},
		stepId(){
			return this.$store.state.page.initial.step;
		},

	},
	methods: {
	},
	created() {

	}
}
</script>

<style lang="scss" scoped>
.manage-products-panel {
.button {
	text-wrap: none;
	white-space: nowrap;
}
}
</style>
